import { Button, SwotPwaUpdateNotice } from "@swot";
import { useCmtsPwaUpdate } from "../../hooks/useCmtsPwaUpdate.js";

export function CmtsPwaUpdateBanner() {
  const { state, acceptUpdate, cleanupCaches, dismissUpdate } = useCmtsPwaUpdate();
  if (!state.updateBannerVisible && !state.errorMessage && state.cacheCleanupStatus !== "failed") return null;
  return (
    <SwotPwaUpdateNotice title={state.errorMessage ? "CMTS update needs attention" : "A new CMTS version is available"}>
      <p>{state.errorMessage ?? "A new version of CMTS is available. Refresh to update and clear old cached files."}</p>
      {state.serviceWorkerVersion ? <p>Version: {state.serviceWorkerVersion}</p> : null}
      <div className="cmts-pwa-banner-actions">
        {state.updateReady || state.updateAvailable ? <Button label={state.updateInstalling ? "Updating..." : "Refresh to update"} variant="primary" loading={state.updateInstalling} onClick={() => void acceptUpdate()} /> : null}
        <Button label={state.cacheCleanupStatus === "running" ? "Cleaning cache..." : "Clean old CMTS cache"} variant="secondary" loading={state.cacheCleanupStatus === "running"} onClick={() => void cleanupCaches()} />
        <Button label="Dismiss" variant="ghost" onClick={dismissUpdate} />
      </div>
    </SwotPwaUpdateNotice>
  );
}
